// Third-party libraries
import React, { useEffect } from "react";
import { Container, Typography } from "@mui/material";

// Local modules
import { Mobile, Default } from "../../../../utils/deviceHelpers";

export default function AuctionSignUp(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container maxWidth="xl">
      <Mobile>
        <iframe
          title="AuctionSignUpForm"
          width="100%"
          height="500px"
          src="https://form.jotform.com/210111834619448"
        />
      </Mobile>
      <Default>
        <Typography variant="articleTitle" className="center">
          Harmony Auction Signup
        </Typography>
        <Typography variant="h6" className="center">
          Part 1
        </Typography>
        <iframe
          title="AuctionSignUpForm"
          width="100%"
          height="500px"
          src="https://form.jotform.com/210111834619448"
        />
      </Default>
    </Container>
  );
}
